import React, { useState, useEffect } from "react";
import {
  FaHospital,
  FaPills,
  FaFileInvoiceDollar,
  FaMedkit,
} from "react-icons/fa";

import img1 from "../../../assets/img/Industries/LogisticsandSupplyChain/freight.jpg";
import img2 from "../../../assets/img/Industries/LogisticsandSupplyChain/warehouse.jpg";
import img3 from "../../../assets/img/Industries/LogisticsandSupplyChain/globalchain.jpg";
import img4 from "../../../assets/img/Industries/LogisticsandSupplyChain/lastmile.jpg";

const HealthcareCard = ({ title, description, icon, imageUrl }) => (
  <div className="bg-white rounded-2xl shadow-xl w-full overflow-hidden transition-all duration-300 hover:shadow-2xl hover:scale-105 mx-auto">
    <div className="h-48 overflow-hidden">
      <img src={imageUrl} alt={title} className="w-full h-full object-cover" />
    </div>
    <div className="p-6">
      <div className="flex items-center mb-4">
        {/* <div className="text-3xl text-blue-600 mr-3">{icon}</div> */}
        <h3 className="text-xl font-bold text-gray-800 min-h-[60px]">{title}</h3>
      </div>
      <p className="text-gray-600">{description}</p>
    </div>
  </div>
);

const Logistics = () => {
  const healthcareAreas = [
    {
      title: "Freight Management",
      description:
        "Optimize freight routes, improve load planning, and enhance vehicle utilization with IoT and analytics.",
      icon: <FaHospital />,
      imageUrl: img1,
    },
    {
      title: "Warehouse and Inventory",
      description:
        "Reduce errors, increase throughput, and improve inventory accuracy with smart warehousing solutions.",
      icon: <FaPills />,
      imageUrl: img2,
    },
    {
      title: "Last-Mile Delivery",
      description:
        "Deliver superior customer experiences with real-time tracking, optimized delivery routes, and autonomous solutions.",
      icon: <FaFileInvoiceDollar />,
      imageUrl: img4,
    },
    {
      title: "Global Supply Chains",
      description:
        "Build resilience against disruptions with blockchain-based traceability and AI-driven risk management.",
      icon: <FaMedkit />,
      imageUrl: img3,
    },
  ];

  return (
    <div className="min-h-[70vh] bg-gradient-to-br from-blue-50 to-green-50 py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-4xl font-bold text-center text-gray-800 mb-4">
          Transforming Key Areas of Logistics & Supply Chain
        </h1>
        <p className="text-xl text-center text-gray-600 mb-12">
          Optimize freight, enhance warehousing, streamline last-mile delivery,
          and build resilient global supply chains with advanced technologies.
        </p>
        <div className="grid grid-cols-1 w-full md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-4 gap-14">
          {healthcareAreas.map((area, index) => (
            <HealthcareCard key={index} {...area} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Logistics;
